
import { defineComponent, PropType } from 'vue';
import { IClaimReplacementProductBox } from '@/types';

export default defineComponent({
  name: 'ReplacementItemList',
  props: {
    replacementProductBoxes: Array as PropType<IClaimReplacementProductBox[]>,
  },
  emits: ['input'],
  setup() {
    function isCancelled(box: any) {
      return !box.orderStatus || !box.orderStatus.includes('CANCEL');
    }

    return { isCancelled };
  },
});
